<template>
  <div>
    <p v-if="taskLabel" class="notification_label">You have an overdue task labeled '{{ taskLabel }}'</p>
    <p v-else class="notification_label">You have an overdue task</p>
    <button-link @click="goToLead">{{ notification.data.record_address }}</button-link>
  </div>
</template>

<script>
import api from "../../../api";
import dates from "../../../services/dates";
import router from "../../../router";

export default {
  name: "TaskAssignedDueNotification",
  props: {
    notification: Object
  },
  computed: {
    taskLabel() {
      if (this.notification.data.hasOwnProperty('task_label')) {
        return this.notification.data.task_label
      }
      return null
    }
  },
  methods: {
    goToLead() {
      api.notifications.markRead({ notification_id: this.notification.id }).then(() => {
        // NOTE: The database read_at will be different from now, but read_at just needs a date
        // in order for this to work. We don't show the read at time.
        this.notification.read_at = dates.getNowISO()
      })
      router.replace({query: {lead: this.notification.data.record_id}});
    },
  },
}
</script>

<style scoped lang="scss">
.notification_label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
</style>
